import React from 'react';

import type { Vulnerability } from '@rtkwlf/mr-infra-risk';
import { useTranslation } from 'react-i18next';

import { Box, Grid, Typography } from '@packages/fenrir/components';

import { ListWithDrawer } from '../../../components/list-with-drawer/list-with-drawer';
import { RowExpansionItem } from '../../../components/row-expansion-item/row-expansion-item';

type VulnerabilitiesRowExpansionProps = {
  row: Vulnerability;
};

export const VulnerabilitiesRowExpansion: React.FC<
  VulnerabilitiesRowExpansionProps
> = ({ row }) => {
  const { t } = useTranslation('riskManagement', {
    keyPrefix: 'vulnerabilities',
  });

  const {
    description,
    recommendations: remediations = [],
    references = [],
    score: cvsBaseScore,
  } = row;

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2}>
        <Grid size={9}>
          <RowExpansionItem title={t('expandedOverview.description')}>
            <Typography variant="body2">{description}</Typography>
          </RowExpansionItem>
        </Grid>
        <Grid size={3}>
          <RowExpansionItem title={t('expandedScores.cvssv3BaseScore')}>
            <Typography variant="body2">{cvsBaseScore}</Typography>
          </RowExpansionItem>
        </Grid>
        <Grid size={9}>
          <RowExpansionItem title={t('expandedOverview.remediation')}>
            {remediations.length && (
              <ListWithDrawer
                title={t('expandedOverview.remediation')}
                list={remediations}
              />
            )}
          </RowExpansionItem>
        </Grid>
        <Grid size={9}>
          <RowExpansionItem title={t('expandedOverview.references')}>
            {references.length && (
              <ListWithDrawer
                title={t('expandedOverview.references')}
                list={references}
                type="link"
              />
            )}
          </RowExpansionItem>
        </Grid>
      </Grid>
    </Box>
  );
};
